module.exports = __webpack_public_path__ + "static/img/3-6.b6617cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3-6.png
// module id = O9Xx
// module chunks = 1